import { render } from "./editPassWordDiasg.vue?vue&type=template&id=31595514&scoped=true"
import script from "./editPassWordDiasg.vue?vue&type=script&lang=js"
export * from "./editPassWordDiasg.vue?vue&type=script&lang=js"

import "./editPassWordDiasg.vue?vue&type=style&index=0&id=31595514&scoped=true&lang=less"
import "./editPassWordDiasg.vue?vue&type=style&index=1&id=31595514&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31595514"]])

export default __exports__